var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-control-structure-default-value-wrapper" },
    [
      _vm.currentData.type === "currency"
        ? _c(_setup.FormControlTypeCurrency, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
            },
          })
        : _vm.currentData.type === "date"
        ? _c(_setup.FormControlTypeCheckbox, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
            },
          })
        : _vm.currentData.type === "number"
        ? _c(_setup.FormControlTypeNumber, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
            },
          })
        : _vm.currentData.type === "select"
        ? _c(_setup.FormControlTypeText, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
            },
          })
        : _vm.currentData.type === "text"
        ? _c(_setup.FormControlTypeText, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
            },
          })
        : _vm.currentData.type === "textarea"
        ? _c(_setup.FormControlTypeTextarea, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
            },
          })
        : _vm.currentData.type === "texteditor"
        ? _c(_setup.FormControlTypeTextarea, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }